import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Post } from '../../../types';
import "./style.css";
import "./share-modal.css";
import { useAiMentionLimitBanner } from '../../../hooks/useAiMentionLimit';
import AiLimitBanner from '../../ai-limit-banner';
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from 'axios';
import { CheckCircle, Clock, Facebook, Heart, Instagram, MessageCircle, Repeat, Smile, Twitter, UserMinus } from 'react-feather';
import { useMessage } from '../../../global-components/src';
import { useAuth } from '../../../global-components/src';
import ImgVerified from '../../imgVerified/ImgVerified';
import { LIMIT_TEXT_COMMENT, PACOCA_API_URL, PACOCA_URL } from '../../../global-components/src/utils/vars';
import { getImageUser, validatePrev } from '../../../global-components/src/utils/auth';
import BottomSheet from '../../bottom-sheet/bottom-sheet';
import { formatNumber } from '../../../utils/numbers';
import { debounce } from "lodash";
import { UserSearchLoadin } from '../../../pages/Settings/SearchScreen/User/UserSearchLoading';
import Spinner from '../../../global-components/src/components/spinner/spiner';
import { Bookmark, Laugh, Link, Send, UsersRound, X } from 'lucide-react';
import { censorText, clearText, errorMessage, verifyLinks } from '../../../global-components/src/utils/text';
import { getNativeKeyboardHeight, getNativeNavigationHeight, isNewApp, isNewAppAndroid } from '../../../utils/platform';
import { isIOSWebView } from '../../../global-components/src/utils/platform';
import PreviewSearch from '../../../pages/Settings/SearchScreen/preview-search';
import FormVerifyEmail from '../../FormVerifyEmail/FormVerifyEmail';
import EmojiPickerNative from '../../Textarea/Emojis/emoji-picker-native';
import { t } from '../../../global-components/src/i18nTranslate';
import { FaWhatsapp } from 'react-icons/fa';
import ReactionPicker from '../../reaction-picker/reaction-picker';
import { useReactionTypes } from '../../../contexts/ReactionsContext';
import { usePostReaction } from '../../../hooks/usePostReaction';
import ReactionSummary from '../../reaction-summary/reaction-summary';
import { UserSearchLoadingSend } from '../../../pages/Settings/SearchScreen/User/UserSearchLoadingSend';
import { getChatListCacheKey } from '../../../utils/chat-list-cache';
    interface OptionsPostProps {
        post: Post; // Define que posts é um array de Post
        setPost?: React.Dispatch<React.SetStateAction<Post | null>>;
        setPosts?: React.Dispatch<React.SetStateAction<Post[]>>;
        onRepost: () => void; // Adicionado
        onOpenLikes?: () => void; // Adicionado
        onSaved?: (isSave: boolean) => Promise<number>;
        onCloseModals?: () => void; // Adicionado
        onOpenComments?: () => void; // Adicionado
    }

    interface PersonToShare{
        id: number
        img_account: string
        name: string
    }

const OptionsPost: React.FC<OptionsPostProps> = ({ post, setPost, setPosts, onRepost, onOpenLikes, onOpenComments, onSaved, onCloseModals }) => {
    const reactionTypes = useReactionTypes();
    const { userReaction, totalLikes, react } = usePostReaction({ post, setPosts });
    const { isAuthenticated, token } = useAuth();
    const navigate = useNavigate();
    const [bottomPadding, setBottomPadding] = useState(0);
    const [liked, setLiked] = useState(post?.liked); // Estado para controlar se a postagem foi curtida
    const [reposted, setReposted] = useState(false); // Estado para controlar se a postagem foi curtida
    const [totalLikes2, setTotalLikes] = useState(post?.total_likes || 0); // Inicializa com o número de curtidas
    const [totalReposts, setTotalReposts] = useState(post?.original_post?.total_shares || post?.total_shares || 0); // Inicializa com o número de curtidas
    const [totalComments, setTotalComments] = useState(post?.total_comments || 0); // Inicializa com o número de curtidas
    const [totalSaved, setTotalSaved] = useState(post?.total_saved || 0); // Inicializa com o número de curtidas
    const [isSaved, setIsSaved] = useState(post?.is_saved); // Inicializa com o número de curtidas
    const [isSendComment, setIsSendComment] = useState(false);
    const [hasNewComment, setHasNewComment] = useState(false);
    const [formNewCommentVisible, setFormNewCommentVisible] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [text, setText] = useState("");
    const [newComment, setNewComment] = useState("");
    const [newGif, setNewGif] = useState<string | null>(null);
    const { setMessage } = useMessage();
    const { user, fetchUser } = useAuth();
    const isModerationLocked = post.id_user === user?.id
        && ['pending', 'review'].includes(post.image_moderation_status ?? '');
    const aiLimitBannerName = useAiMentionLimitBanner(text, user?.id);
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const img = getImageUser(user?.img_account);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const minHeight = 20; // Altura mínima inicial
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const [openShare, setOpenShare] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [termo, setTermo] = useState(searchParams.get("termo") || "");
    const [personsToShare, setPersonsToShare] = useState<PersonToShare[] | null>(null);
    const [loadingPersons, setLoadinPersons] = useState<boolean>(false);
    const [termoSearch, setTermoSearch] = useState(termo);
    const [selectedPersons, setSelectedPersons] = useState<number[]>([]);
    const [page, setPage] = useState(() => { return 0; });
    const [loadingSendMessage, setLoadingSendMessage] = useState(false);
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const openRef = useRef<HTMLButtonElement | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    const isMobile = window.innerWidth <= 850;
    const touchStartY = useRef(0);
    const pressTimer = useRef<any>(null);
    const held = useRef(false);
    const [showEmoji, setShowEmoji] = useState(false);
    const [pulseLike, setPulseLike] = useState(false);
    const [pulseComment, setPulseComment] = useState(false);
    const [pulseSave, setPulseSave] = useState(false);
    const updateText = (newText: string) => {
        setText(newText); // Atualiza o estado com o novo texto
    };

    const triggerPulse = (setState: React.Dispatch<React.SetStateAction<boolean>>) => {
        setState(true);
        setTimeout(() => setState(false), 250);
    };

    useEffect(() => {
        setLiked(post?.liked);
        setTotalLikes(post?.total_likes);
    }, [post?.liked]);

    const toggleSelectPerson = (id: number) => {
        setSelectedPersons(prev => 
            prev.includes(id)
                ? prev.filter(item => item !== id)   // REMOVE
                : [...prev, id]                       // ADICIONA
        );
    };

    useEffect(() => {
        const handleKeyboardHeightChange = () => {
            const heightKeyboard = getNativeKeyboardHeight();
            const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;

            setBottomPadding(heightKeyboard ? heightKeyboard + nativeNavigationHeight : nativeNavigationHeight);
        };

        window.addEventListener("keyboardHeightChange", handleKeyboardHeightChange);

        return () => {
            window.removeEventListener("keyboardHeightChange", handleKeyboardHeightChange);
        };
    }, []);

        
    function ajustaNewApp() {
        if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
            const nativeNavigationHeight = getNativeNavigationHeight();
            const heightKeyboard = getNativeKeyboardHeight();

            if(nativeNavigationHeight && nativeNavigationHeight > 0){
                setBottomPadding(nativeNavigationHeight + (heightKeyboard ? 20 : 0));
            }

            window.addEventListener("navigationBarHeightChange", ajustaNewApp);
            return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
        }
    }
    useEffect(() => {
        ajustaNewApp()
    }, []);

    const handleSendMessage = async() => {
        setLoadingSendMessage(true);
        const config = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`
            }
        }

        closeRef.current?.click();
        setOpenShare(false);
        setMessage(t("post.messageSent"), "success");
        setSelectedPersons([]);

        try {
            if(!selectedPersons.length) return;
            // Cria uma lista de Promises para enviar tudo de uma vez
            const promises = selectedPersons?.map((person) => {
                
                const formData = new FormData();
                formData.append("text", `${PACOCA_URL}/post/${post.id}`);
                formData.append("user_id", String(person));

                return axios.post(
                    `${PACOCA_API_URL}/chats/messages/`,
                    formData,
                    config
                );
            });

            // Aguarda todas as mensagens serem enviadas
            await Promise.all(promises);
            setMessage(t("post.messageSent"), "success");
        } catch (error) {
            console.error(error);
            setMessage(t("generics.errors.genericServerError"), "error");
        } finally {
            setLoadingSendMessage(false);
        }
    }

    useEffect(() => {
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", () => onCloseModals ? onCloseModals() : () => {});

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", () => onCloseModals ? onCloseModals() : () => {});
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", () => onCloseModals ? onCloseModals() : () => {});

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", () => onCloseModals ? onCloseModals() : () => {});
        };
    }, []);

    const sendPost = () => {
        if(window.innerWidth <= 850)
            setOpenShare(true);
        else
            openRef.current?.click();
    };

    const copyLinkPost = () => {
        const link = `${window.location.origin}/post/${post?.id}`;
        if (navigator.share) {
            navigator.share({
                title: 'Compartilhar Post',
                url: link,
            }).catch((error) => console.error('Erro ao compartilhar o link:', error)).finally(() => setOpenShare(false));
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link)
                .then(() => setMessage(t("post.linkCopied"), "success"))
                .catch((error) => console.error('Erro ao copiar o link:', error)).finally(() => setOpenShare(false));
        } else {
            alert('Copie este link: ' + link);
            setOpenShare(false)
        }
    };

    const shareFacebook = () => {
        const link = `${window.location.origin}/post/${post?.id}`;
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`, "_blank");
        setOpenShare(false);
    };

    const shareTwitter = () => {
        const link = `${window.location.origin}/post/${post?.id}`;

        const text = encodeURIComponent(
            `Olha esse post que achei 👇\n\n${link}`
        );

        window.open(`https://twitter.com/intent/tweet?text=${text}`, "_blank");

        setOpenShare(false);
    };

    const shareInstagram = async () => {
        const link = `${window.location.origin}/post/${post?.id}`;

        try {
            await navigator.clipboard.writeText(link);
            setMessage(t("post.linkCopiedInstagram"), "success");
        } catch {
            alert("Copie o link: " + link);
        }

         setTimeout(() => {
            const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

            if (isMobile) {
                window.location.href = "instagram://direct/inbox";
            } else {
                window.open("https://www.instagram.com/direct/inbox/", "_blank");
            }

            setOpenShare(false);
        }, 1000);

        setOpenShare(false);
    };

    const shareWhatsApp = () => {
        const link = `${window.location.origin}/post/${post?.id}`;
        const text = encodeURIComponent(`Olha esse post que achei no Paçoca 👇\n\n${link}\n`);

        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (isMobile) {
            window.open(`https://wa.me/?text=${text}`, "_blank");
        } else {
            window.open(`https://web.whatsapp.com/send?text=${text}`, "_blank");
        }

        setOpenShare(false);
    };

    const handleSubmitComment = async (event: any, textLocal = text, isGif = false) => {
        if(event) event.preventDefault(); // Impede o envio do formulário
        if(textLocal && verifyLinks(textLocal)){
            setMessage("Link suspeito, você não pode realizar esse comentário", "error");
            return;
        }

        const validate = validatePrev(user);
        if(validate){
            setMessage(validate, "error", undefined, undefined);
            return;
        }

        const url = PACOCA_API_URL + "/comments/" + post?.id
        const oldtext = textLocal;
        setDisabled(true);
        setHasNewComment(true)
        setNewComment(textLocal);
        if(isGif) setNewGif(textLocal);

        // Criação do objeto FormData
        const formData = new FormData();
        if(isGif) formData.append("gif_url", text);
        formData.append("comment", textLocal);

        setText("")
        try {
            await axios.post(url, formData, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            })

            setTotalComments(totalComments + 1)
            setIsSendComment(true)
        } catch (err: any) {
            setText(oldtext)
            setHasNewComment(false)
            setDisabled(false);
            setTotalReposts(prev => prev - 1); // desfaz o incremento
            const messageError = errorMessage(err);
            const reason = err?.response?.data.reason && err?.response?.status == 403 ? err?.response?.data.reason : null;
            setMessage(messageError || "Erro ao enviar o aviso.", "error", undefined, undefined, reason);
            console.error("Erro ao repostar agora:", err);
            console.error(messageError);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        const screenWidth = window.innerWidth;

        if (e.key === "Enter") {
            if (e.shiftKey || screenWidth <= 850) {
                e.preventDefault();

                const textarea = e.currentTarget;
                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;

                setText((prev) => {
                    const newText =
                        prev.substring(0, start) +
                        "\n" +
                        prev.substring(end);

                    // reposiciona o cursor após o React atualizar o estado
                    setTimeout(() => {
                        textarea.selectionStart = textarea.selectionEnd = start + 1;
                    }, 0);

                    return newText;
                });
            } else if (screenWidth > 850 && text.trim().length > 0) {
                e.preventDefault();
                handleSubmitComment(e as any);
            }
        }
    };

    // const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    //     const screenWidth = window.innerWidth; // Obtém a largura da tela

    //     if (e.key === "Enter") {
    //         e.preventDefault(); // Evita o comportamento padrão
    //         if (e.shiftKey || screenWidth <= 850) {
    //             setText((prevText) => prevText + "\n"); // Adiciona uma nova linha
    //         } else if (screenWidth > 850 && text.trim().length > 0) {
    //             handleSubmitComment(e as any); // Dispara o envio do formulário
    //         }
    //     }
    // };

    const handleInputTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newText = event.target.value;
        setText(newText);
        setIsLimitExceeded(newText.length > LIMIT_TEXT_COMMENT);
        adjustTextareaHeight();
    }

    // Função para ajustar a altura dinamicamente
    const adjustTextareaHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reseta a altura para calcular corretamente
            const newHeight = Math.max(minHeight, textareaRef.current.scrollHeight); // Garante a altura mínima
            textareaRef.current.style.height = `${newHeight}px`;
        }
    };

    const handleRepostNow = async () => {
        let idPost = post?.original_post_id ? post?.original_post_id : post?.id
        const url = PACOCA_API_URL + `/posts/repost-now/${idPost}`;
        
        if (!isAuthenticated) {
            return navigate("/login")
        }

        try {
            setTotalReposts(prev => prev + 1); // desfaz o incremento

            await axios.post(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            });

            setReposted(true);
            setMessage(t("post.shared"), "success")
        } catch (err: any) {
            setReposted(false);
            setTotalReposts(prev => prev - 1); // desfaz o incremento
            const messageError = errorMessage(err);
            const reason = err?.response?.data.reason && err?.response?.status == 403 ? err?.response?.data.reason : null;
            setMessage(messageError || "Erro ao enviar o aviso.", "error", undefined, undefined, reason);
            console.error("Erro ao repostar agora:", err);
            console.error(messageError);
        }
    }
    
    const handleDeleteRepost = async () => {
        let idPost = post?.original_post_id ? post?.original_post_id : post?.id
        const url = PACOCA_API_URL + `/posts/${idPost}`;
        
        if (!isAuthenticated) {
            return navigate("/login")
        }

        try {
            setTotalReposts(prev => prev - 1); // desfaz o incremento

            await axios.delete(url, {
                params: { id_post: idPost },
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            setReposted(false);
            setMessage(t("post.repostDeleted"), "success")
        } catch (err: any) {
            setTotalReposts(prev => prev + 1); // desfaz o incremento
            const messageError = errorMessage(err);
            const reason = err?.response?.data.reason && err?.response?.status == 403 ? err?.response?.data.reason : null;
            setMessage(messageError || "Erro ao enviar o aviso.", "error", undefined, undefined, reason);
            console.error("Erro ao repostar agora:", err);
            console.error(messageError);
        }
    }

    const handleRedirectToReposts = () => {
        if(totalReposts || post?.original_post_id)
            navigate(`/reposts/${post?.original_post_id ? post?.original_post_id : post?.id}`);
    };

    const handleClickEmoji = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        setText((prev) => {
            if (prev[start - 1] === ":") return prev;

            const needsSpaceBefore =
                start > 0 && prev[start - 1] !== " " && prev[start - 1] !== "\n";

            const insertText = needsSpaceBefore ? " :" : ":";

            const newText =
                prev.substring(0, start) +
                insertText +
                prev.substring(end);

            setTimeout(() => {
                const pos = start + insertText.length;

                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = pos;

                // 🔥 SIMULA DIGITAÇÃO REAL
                textarea.dispatchEvent(new Event("input", { bubbles: true }));
            }, 0);

            return newText;
        });
    };

    useEffect(() => {
        adjustTextareaHeight(); // Ajusta a altura ao montar o componente ou mudar o texto
        if (text.length <= LIMIT_TEXT_COMMENT && text.trim().length > 0) setDisabled(false)
        else setDisabled(true)
    }, [text]);

    const handleLike = async () => {
        triggerPulse(setPulseLike);
        const url = PACOCA_API_URL + `/posts/${!post?.liked ? "like" : "unlike"}/${post?.id}`;
        const originalTotalLikes = totalLikes;
        const originalisLiked = liked;

        if (!isAuthenticated) {
            return navigate("/login")
        }

        const validate = validatePrev(user);
        if(validate){
            setMessage(validate, "error", undefined, undefined);
            return;
        }

        // Atualiza o estado imediatamente antes de fazer a requisição
        const newLikedState = !liked;
        const newTotalLikes = newLikedState ? totalLikes + 1 : Math.max(totalLikes - 1, 0);
        
        try {
            
            setLiked(newLikedState); // Atualiza o estado de curtida
            setTotalLikes(newTotalLikes); // Atualiza o total de curtidas
            if(setPost)
                setPost(prev => !prev ? prev : ({
                    ...prev,
                    liked: newLikedState,
                    total_likes: newTotalLikes
                }));
            
            if(setPosts)
                setPosts(prev => !prev ? prev :
                    prev.map(p =>
                        p.id === post?.id
                            ? {
                                ...p,
                                liked: newLikedState,
                                total_likes: newTotalLikes
                            }
                            : p
                    )
                );



            const response = await axios.post(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            })
            if (response.data.total_likes) setTotalLikes(response.data.total_likes); // Atualiza o total de curtidas
        } catch (err: any) {
            const messageError = errorMessage(err);
            console.error("Erro ao repostar agora:", err);
            console.error(messageError);
            if([401, 403, 429].includes(err?.response?.status)){
                setLiked(originalisLiked);
                setTotalLikes(originalTotalLikes);
                const reason = err?.response?.data.reason && err?.response?.status == 403 ? err?.response?.data.reason : null;
                setMessage(messageError || "Erro ao enviar o aviso.", "error", undefined, undefined, reason);
            }
        }
    };

    const handleSave = async () => {
        triggerPulse(setPulseSave);
        const url = PACOCA_API_URL + `/posts/${post?.is_saved ? "unsave" : "save"}/${post?.id}`;
        const originalTotalLikes = totalSaved;
        const originalisLiked = isSaved;

        if (!isAuthenticated) {
            return navigate("/login")
        }

        const validate = validatePrev(user);
        if(validate){
            setMessage(validate, "error", undefined, undefined);
            return;
        }

        // Atualiza o estado imediatamente antes de fazer a requisição
        const newLikedState = !isSaved;
        const newTotalLikes = newLikedState ? totalSaved + 1 : Math.max(totalSaved - 1, 0);
        
        try {
            
            setIsSaved(newLikedState); // Atualiza o estado de curtida
            setTotalSaved(newTotalLikes); // Atualiza o total de curtidas
            if(setPost)
                setPost(prev => !prev ? prev : ({
                    ...prev,
                    is_saved: newLikedState,
                    total_saved: newTotalLikes
                }));
            
            if(setPosts)
                setPosts(prev => !prev ? prev :
                    prev.map(p =>
                        p.id === post?.id
                            ? {
                                ...p,
                                is_saved: newLikedState,
                                total_saved: newTotalLikes
                            }
                            : p
                    )
                );


            const response = await axios.post(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            })
            if (response.data.total_likes) setTotalSaved(response.data.total_likes); // Atualiza o total de curtidas
        } catch (err: any) {
            const messageError = errorMessage(err);
            console.error("Erro ao repostar agora:", err);
            console.error(messageError);
            if([401, 403, 429].includes(err?.response?.status)){
                setIsSaved(originalisLiked);
                setTotalSaved(originalTotalLikes);
                const reason = err?.response?.data.reason && err?.response?.status == 403 ? err?.response?.data.reason : null;
                setMessage(messageError || "Erro ao enviar o aviso.", "error", undefined, undefined, reason);
            }
        }
    };

    useEffect(() => {
        if(!termoSearch.length) loadChats();
        if(termoSearch.length) loadFollowing();
        // if(openShare && !termoSearch.length) loadChats();
    }, [openShare, termoSearch]);

    const loadFollowing = async (newPage?: number) => {
        // setDataNotFound(false)
        const currentPage = newPage ?? page + 1; // Usa newPage se fornecido, senão incrementa
        const url = PACOCA_API_URL + `/users/following/${user?.id}?page=${currentPage}&followingType=all&search=${termoSearch}`;
        

        if (loading) return;
        setLoadinPersons(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.following.length > 0) {
                const mapped = data.following.map((following: any) => ({
                    id: following.id,
                    img_account: following.img_account,
                    name: following.name
                })) as PersonToShare[];

                setPersonsToShare(mapped);

            } else {
                // setHasMore(false);
            }

        } catch (err: any) {
            const messageError = errorMessage(err)
            setMessage(messageError, "error");
            console.error('Erro:', err);
            // setEnd(true);
        } finally {
            setLoadinPersons(false);
            // setLoadingTermo(false)
        }
    };

    const loadChats = async () => {
        setLoadinPersons(true);
        const localKey = getChatListCacheKey(user?.id);
        const localChatsRaw = localStorage.getItem(localKey);
        let localChats: any[] = [];

        if (localChatsRaw && !termoSearch.trim().length) {
            try {
                localChats = JSON.parse(localChatsRaw);
                const mapped = localChats.map(chat => ({
                    id: chat.user_id,
                    img_account: chat.img_account,
                    name: chat.name
                })) as PersonToShare[];

                setPersonsToShare(mapped);
            } catch (e) {
                console.warn("Erro ao ler chats locais:", e);
            }
        }

        setLoadinPersons(false);
    }

    const debouncedHandleInput = useCallback(debounce(setTermoSearch, 500), [termoSearch]);
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLoadinPersons(true);
        const inputValue = event.target.value;
        setTermo(inputValue)
        debouncedHandleInput(inputValue)
        setPersonsToShare([])
        setSearchParams({ termo: inputValue }, { replace: true })
    };
    
    const HOLD_TIME = 500; // tempo para considerar "segurar"
    // const isMobile = window.innerWidth <= 850;
    // let pressTimer: any;
    // let held = false;

    // const startHold = (e: any, type?: "mouse" | "touch") => {
    //     e.preventDefault();
    //     if (type == "mouse" && window.innerWidth <= 850) return;
        
    //     held.current = false;
        
    //     pressTimer.current = setTimeout(() => {
    //         held.current = true;
            
    //         if (!isAuthenticated) return navigate("/login");
            
    //         // Só chama onOpenLikes se tiver likes
    //         if (onOpenLikes && totalLikes > 0) {
    //             onOpenLikes();
    //         }
    //     }, HOLD_TIME);
    // };

    const cancelHold = () => {
        if (pressTimer.current) {
            clearTimeout(pressTimer.current);
            pressTimer.current = null;
        }
    };

    // const handleTouchStart = (e: any) => {
    //     touchStartY.current = e.touches[0].clientY;
    //     startHold(e);
    // };

    const handleTouchMove = (e: any) => {
        const touchY = e.touches[0].clientY;
        const deltaY = Math.abs(touchY - touchStartY.current);
        
        if (deltaY > 10) {
            setIsDragging(true);
            cancelHold();
        }
    };

    // const handleTouchEnd = async (e: any, isHeart = false) => {
    //     if (isDragging) {
    //         setIsDragging(false);
    //         cancelHold();
    //         return;
    //     }
        
    //     cancelHold();
        
    //     // Se não foi segurar (hold), executa ação de clique
    //     if (!held.current) {
    //         if (isMobile) {
    //             // MOBILE: Clique rápido em ambos = curtir
    //             await handleLike();
    //         } else if (!isHeart && totalLikes > 0) {
    //             // DESKTOP: Número clicado = abrir likes
    //             onOpenLikes?.();
    //         } else if (isHeart) {
    //             // DESKTOP: Heart clicado = curtir
    //             await handleLike();
    //         }
    //     }
        
    //     held.current = false;
    // };

    const handleClickGif = (sticky: string) => {
        const oldText = text;
        handleSubmitComment(null, sticky, true);
        setText(oldText.slice(0, oldText.length - 1));
    }

    if (isModerationLocked) {
        return (
            <div className="post-moderation-status" role="status">
                {t('post.hiddenByAiReason', { reason: post.hidden_reason || 'Em análise' })}
            </div>
        );
    }

    return (
        <>
            {/* Ícones sobrepostos + contagem, clica para abrir lista */}
            <ReactionSummary
                slugs={
                    // post.reaction_summary pode vir como string JSON ou array
                    typeof (post as any).reaction_summary === "string"
                        ? JSON.parse((post as any).reaction_summary ?? "[]")
                        : ((post as any).reaction_summary ?? [])
                }
                totalLikes={totalLikes}
                onClick={totalLikes > 1 ? onOpenLikes : undefined}
            />
            <div className="row row-info-post user-select-none">
                <div className='d-flex' style={{ width: "auto", marginTop: totalLikes > 0 ? -7 : 0 }}>
                    <div className="col-a">
                        <div className="user-select-none button-like col-icon-post col col-like">
                            {/* --- CORAÇÃO --- */}
                            {/* <Heart 
                                // Desktop events
                                onMouseDown={!isMobile ? startHold : undefined}
                                onMouseUp={!isMobile ? () => cancelHold() : undefined}
                                onMouseLeave={!isMobile ? cancelHold : undefined}
                                
                                // Mobile events
                                onTouchStart={isMobile ? handleTouchStart : handleTouchStart}
                                onTouchMove={isMobile ? handleTouchMove : handleTouchMove}
                                onTouchEnd={isMobile ? (e) => handleTouchEnd(e, true) : (e) =>  handleTouchEnd(e, true)}
                                onTouchCancel={isMobile ? cancelHold : cancelHold}
                                
                                // Clique (só para desktop heart)
                                onClick={!isMobile ? handleLike : undefined}
                                
                                className={`icon-post ${liked ? "like-red" : ""} ${pulseLike ? "pulse" : ""}`}
                                style={{ 
                                    fill: liked ? "red" : "",
                                    cursor: "pointer"
                                }}
                            /> */}
                    {/* <ReactionPicker
                        reactions={reactionTypes}
                        userReaction={userReaction}
                        totalLikes={totalLikes}
                        onOpenLikes={onOpenLikes}
                        onReact={(slug) => {
                            if (!isAuthenticated) { navigate("/login"); return; }
                            const validate = validatePrev(user);
                            if (validate) { setMessage(validate, "error", undefined, undefined); return; }
                            react(slug);
                        }}
                    /> */}
                        <ReactionPicker
                            reactions={reactionTypes}
                            userReaction={userReaction}
                            totalLikes={totalLikes}
                            onReact={(slug) => {
                                if (!isAuthenticated) { navigate("/login"); return; }
                                const validate = validatePrev(user);
                                if (validate) { setMessage(validate, "error", undefined, undefined); return; }
                                react(slug);
                            }}
                        />
                            {/* Número de likes */}
                            {/* <span
                                // Desktop events
                                onMouseDown={!isMobile ? startHold : undefined}
                                onMouseUp={!isMobile ? cancelHold : undefined}
                                onMouseLeave={!isMobile ? cancelHold : undefined}
                                
                                // Mobile events
                                onTouchStart={isMobile ? handleTouchStart : undefined}
                                onTouchMove={isMobile ? handleTouchMove : undefined}
                                onTouchEnd={isMobile ? (e) => handleTouchEnd(e, false) : undefined}
                                onTouchCancel={isMobile ? cancelHold : undefined}
                                
                                // Clique (só para desktop número)
                                onClick={!isMobile && totalLikes > 0 ? () => onOpenLikes?.() : undefined}
                                
                                style={{
                                    minWidth: 12,
                                    marginLeft: 3,
                                    paddingRight: 5,
                                    cursor: totalLikes > 0 ? "pointer" : "default",
                                    userSelect: "none",
                                    WebkitUserSelect: "none"
                                }}
                            >
                                {totalLikes > 0 ? formatNumber(totalLikes) : <>&nbsp;</>}
                            </span> */}
                            <span
                                style={{
                                    minWidth: 12,
                                    marginLeft: 3,
                                    paddingRight: 5,
                                    cursor: totalLikes > 0 ? "pointer" : "default",
                                    userSelect: "none",
                                    WebkitUserSelect: "none"
                                }}
                            >
                                <>&nbsp;</>
                            </span>
                        </div>
                    </div>

                    <div className="col-a">
                        <div className="user-select-none button-comment col col-like col-icon-post">
                            <MessageCircle onClick={() => true ? (!isAuthenticated ? navigate("/login") : (onOpenComments && true ? onOpenComments() : () => {})) : setFormNewCommentVisible(!formNewCommentVisible)} className={`icon-post ${pulseComment ? "pulse" : ""}`} data-feather="message-circle" />
                            <span style={{ minWidth: 12,  marginLeft: 3, paddingRight: 10, cursor: true ? "pointer" : "" }} onClick={() => { !isAuthenticated ? navigate("/login") : (onOpenComments && true ? onOpenComments() : () => {}) }}>
                                {totalComments > 0 ? 
                                    <>{formatNumber(totalComments)}</>
                                : <>&nbsp;</>}
                            </span>
                        </div>
                    </div>

                    <div className="user-select-none col-a">
                        <div className="col none-pc" style={{ margin: 0, padding: 0 }}>
                            <div className="col col-like col-icon-post">
                                {reposted ? (
                                    <Repeat onClick={handleDeleteRepost} className="icon-post" data-feather="repeat" />
                                ) : (
                                    <Repeat
                                        onClick={onRepost}
                                        className="icon-post"
                                        data-feather="repeat"
                                        data-bs-toggle="modal"
                                        data-bs-target="#repost-with-text"
                                    />
                                )}
                                <span style={{ minWidth: 12,  marginLeft: 3, paddingRight: 10, cursor: totalReposts > 0 ? "pointer" : "" }} onClick={() => handleRedirectToReposts()}>
                                    {totalReposts > 0 ? 
                                        <>{formatNumber(totalReposts)}</>
                                    : <>&nbsp;</>}
                                </span>
                            </div>
                        </div>

                    
                        <button className="d-none" ref={openRef} data-bs-toggle="modal" data-bs-target={`#modal-post-${post.id}`}>a</button>
                        <div className="col-10">
                            <div className="modal fade" id={`modal-post-${post.id}`} aria-hidden="true">
                                <div className="modal-dialog smc-pc-dialog cover-mobile">
                                    <div id="username-suggestions"></div>
                                    <div className="modal-content smc-pc-modal-content">
                                        <div className="smc-header">
                                            <h4 className="smc-title">{t("post.sendPost")}</h4>
                                            <button ref={closeRef} type="button" className="smc-close" data-bs-dismiss="modal" aria-label="Close">
                                                <X size={15} />
                                            </button>
                                        </div>
                                        <div className="modal-body" style={{ padding: 0, minHeight: 150 }}>
                                            {user && !user?.email_verified_at && isAuthenticated ? (
                                                <div className="body-validate-email">
                                                    <div>{t("post.verifyEmailToShare")}</div>
                                                    <FormVerifyEmail/>
                                                </div>
                                            ) : (
                                                <div className="smc-body">
                                                    <div className="smc-search-wrap">
                                                        <input
                                                            id="input-search-screen"
                                                            className="smc-search-input"
                                                            type="text"
                                                            name="search"
                                                            placeholder={t("generics.search")}
                                                            aria-label="Search"
                                                            value={termo}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="smc-share-grid">
                                                        <UserSearchLoadingSend loading={loadingPersons}/>
                                                    </div>

                                                    {!termo.length && (
                                                        <>
                                                            <div className="smc-section-label">{t("post.shareVia")}</div>
                                                            <div className="smc-share-grid">
                                                                <div onClick={copyLinkPost} className="smc-share-item">
                                                                    <div className="smc-share-icon" style={{ backgroundColor: "var(--secondary-blue)" }}>
                                                                        <Link size={20}/>
                                                                    </div>
                                                                    <span className="smc-share-label">{t("post.copyLink")}</span>
                                                                </div>

                                                                <div onClick={shareWhatsApp} className="smc-share-item">
                                                                    <div className="smc-share-icon" style={{ backgroundColor: "#25D366" }}>
                                                                        <FaWhatsapp size={20}/>
                                                                    </div>
                                                                    <span className="smc-share-label">WhatsApp</span>
                                                                </div>

                                                                <div onClick={shareTwitter} className="smc-share-item">
                                                                    <div className="smc-share-icon" style={{ backgroundColor: "#000000" }}>
                                                                        <Twitter size={20}/>
                                                                    </div>
                                                                    <span className="smc-share-label">X</span>
                                                                </div>

                                                                <div onClick={shareInstagram} className="smc-share-item">
                                                                    <div className="smc-share-icon" style={{ background: "linear-gradient(45deg, #f58529, #dd2a7b, #8134af, #515bd4)" }}>
                                                                        <Instagram size={20}/>
                                                                    </div>
                                                                    <span className="smc-share-label">Instagram</span>
                                                                </div>

                                                                <div onClick={shareFacebook} className="smc-share-item">
                                                                    <div className="smc-share-icon" style={{ backgroundColor: "#1877F2" }}>
                                                                        <Facebook size={20}/>
                                                                    </div>
                                                                    <span className="smc-share-label">Facebook</span>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {personsToShare?.length ? (
                                                        <>
                                                            <div className="smc-section-label">{t("post.sendTo")}</div>
                                                            <div className="smc-people-grid">
                                                                {personsToShare.slice(0, 15).map((person) => (
                                                                    <div
                                                                        onClick={() => toggleSelectPerson(person.id)}
                                                                        key={person.id}
                                                                        className={`smc-person-item ${selectedPersons.includes(person.id) ? "sel" : ""}`}
                                                                    >
                                                                        <div className="smc-person-avatar-wrap">
                                                                            <img
                                                                                src={getImageUser(person?.img_account)}
                                                                                className="smc-person-avatar"
                                                                                onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }}
                                                                            />
                                                                            {selectedPersons.includes(person.id) && (
                                                                                <div className="smc-person-check">
                                                                                    <CheckCircle size={10}/>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <span className="smc-person-label">{person.name.split(" ")[0]}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    ) : !loadingPersons ? (
                                                        <div className="smc-empty">
                                                            <UserMinus size={22}/>
                                                            <span style={{ fontSize: 12 }}>{t("post.noUsersToSend")}</span>
                                                        </div>
                                                    ) : null}

                                                    <div className="smc-actions">
                                                        <button onClick={handleSendMessage} disabled={!selectedPersons.length || loadingSendMessage} className="smc-btn-primary">
                                                            {loadingSendMessage ? <Spinner/> : t("generics.send")}
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <BottomSheet snapPoints={[0, 0.7, 1]} initialSnap={1} setOpen={setOpenShare} open={openShare}>
                            {/* <div className="foc-sheet-handle" /> */}
                            <div className="foc-sheet-header-drop">
                                <h4 className="smc-title">{t("post.sendPost")}</h4>

                                <div className="d-flex" style={{ gap: 5 }}>
                                    <button
                                        type="button"
                                        className="foc-sheet-close"
                                        onClick={() => setOpenShare(false)}
                                        aria-label="Fechar"
                                    >
                                        <X size={16} />
                                    </button>
                                </div>
                            </div>
                            {user && !user?.email_verified_at && isAuthenticated ? (
                                <div className="body-validate-email">
                                    <div><p>{t("post.verifyEmailToShare")}</p></div>
                                    <FormVerifyEmail/>
                                </div>
                            ) : (
                                <div className="smc-body-drop">
                                    <div className="smc-search-wrap" style={{ display: "flex", gap: 8 }}>
                                        <input
                                            id="input-search-screen"
                                            className="smc-search-input"
                                            type="text"
                                            name="search"
                                            placeholder={t("generics.search")}
                                            aria-label="Search"
                                            value={termo}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="smc-share-grid">
                                        <UserSearchLoadingSend loading={loadingPersons}/>
                                    </div>

                                    {!termo.length && (
                                        <>
                                            <div className="smc-section-label">{t("post.shareVia")}</div>
                                            <div className="smc-share-grid">
                                                <div onClick={copyLinkPost} className="smc-share-item">
                                                    <div className="smc-share-icon" style={{ backgroundColor: "var(--secondary-blue)" }}>
                                                        <Link size={20}/>
                                                    </div>
                                                    <span className="smc-share-label">{t("post.copyLink")}</span>
                                                </div>

                                                <div onClick={shareWhatsApp} className="smc-share-item">
                                                    <div className="smc-share-icon" style={{ backgroundColor: "#25D366" }}>
                                                        <FaWhatsapp size={20}/>
                                                    </div>
                                                    <span className="smc-share-label">WhatsApp</span>
                                                </div>

                                                <div onClick={shareTwitter} className="smc-share-item">
                                                    <div className="smc-share-icon" style={{ backgroundColor: "#000000" }}>
                                                        <Twitter size={20}/>
                                                    </div>
                                                    <span className="smc-share-label">X</span>
                                                </div>

                                                <div onClick={shareInstagram} className="smc-share-item">
                                                    <div className="smc-share-icon" style={{ background: "linear-gradient(45deg, #f58529, #dd2a7b, #8134af, #515bd4)" }}>
                                                        <Instagram size={20}/>
                                                    </div>
                                                    <span className="smc-share-label">Instagram</span>
                                                </div>

                                                <div onClick={shareFacebook} className="smc-share-item">
                                                    <div className="smc-share-icon" style={{ backgroundColor: "#1877F2" }}>
                                                        <Facebook size={20}/>
                                                    </div>
                                                    <span className="smc-share-label">Facebook</span>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {personsToShare?.length ? (
                                        <>
                                            <div className="smc-section-label">{t("post.sendTo")}</div>
                                            <div className="smc-people-grid">
                                                {personsToShare.slice(0, 15).map((person) => (
                                                    <div
                                                        onClick={() => toggleSelectPerson(person.id)}
                                                        key={person.id}
                                                        className={`smc-person-item ${selectedPersons.includes(person.id) ? "sel" : ""}`}
                                                    >
                                                        <div className="smc-person-avatar-wrap">
                                                            <img
                                                                src={getImageUser(person?.img_account)}
                                                                className="smc-person-avatar"
                                                                onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }}
                                                            />
                                                            {selectedPersons.includes(person.id) && (
                                                                <div className="smc-person-check">
                                                                    <CheckCircle size={10}/>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <span className="smc-person-label">{person.name.split(" ")[0]}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    ) : !loadingPersons ? (
                                        <div className="smc-empty">
                                            <UserMinus size={22}/>
                                            <span style={{ fontSize: 12 }}>{t("post.noUsersToSend")}</span>
                                        </div>
                                    ) : null}

                                    <div className="smc-actions">
                                        <button onClick={handleSendMessage} disabled={!selectedPersons.length || loadingSendMessage} className="smc-btn-primary">
                                            {loadingSendMessage ? <Spinner/> : t("generics.send")}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </BottomSheet>

                    </div>

                    <div className='none-cel'>
                        <div className="col" style={{ margin: 0, padding: 0 }}>
                            <div className="dropdown col col-like col-icon-post">
                                {reposted ? (
                                    <Repeat
                                        className="icon-post"
                                        data-feather="repeat"
                                        onClick={handleDeleteRepost}
                                    />
                                ) : (
                                    <Repeat
                                        className="icon-post"
                                        data-feather="repeat"
                                        onClick={onRepost}
                                        data-bs-toggle="modal"
                                        data-bs-target="#repost-with-text"
                                    />
                                )}
                                <span style={{ minWidth: 12, marginLeft: 3, paddingRight: 10, cursor: totalReposts > 0 ? "pointer" : "" }} onClick={(e) => { e.preventDefault(); handleRedirectToReposts(); }}>
                                    {totalReposts > 0
                                        ? <>{formatNumber(totalReposts)}</>
                                        : <>&nbsp;</>}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="col-a">
                        <div className="user-select-none button-comment col col-like col-icon-post" onClick={handleSave}>
                            <Bookmark fill={isSaved ? "currentColor" : "none"} className={`icon-post ${pulseSave ? "pulse" : ""}`} />
                            <span style={{ minWidth: 12,  marginLeft: 3, paddingRight: 10, cursor: true ? "pointer" : "" }}>
                                {totalSaved > 0 ? 
                                    <>{formatNumber(totalSaved)}</>
                                : <>&nbsp;</>}
                            </span>
                        </div>
                    </div>
                    
                    <div className="col-a"onClick={sendPost}>
                        <div className="user-select-none button-comment col col-like col-icon-post">
                            <Send className="icon-post" data-feather="send" />
                        </div>
                    </div>
                </div>

                {/* <div className="col-3" onClick={copyLinkPost}>
                    <div className="user-select-none dropdown col col-like col-icon-post col-icon-post-send" style={{ display: "flex", justifyContent: "end" }}>
                        <Send className="icon-post" data-feather="send" />
                    </div>
                </div> */}
            </div>

            {/* previa do comentario */}
            {hasNewComment ? (
                <div className="row row-new-comment" style={{  marginRight: 0, marginLeft: 0 }}>
                    {/* <div className="col-1 img-account-add-comment" style={{ backgroundImage: `url("${img}")` }}>
                    </div> */}
                    <img className="img-account-add-comment" src={`${img}`} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} alt="" />

                    <div className="col">
                        <div className="comment-text">
                            <h1 className="w-100 name-preview-comment" style={{ fontSize: "17px", marginBottom: "5px" }}>
                                <span>
                                    {user?.name}
                                </span>
                                <ImgVerified user={user} classNameProp="img-verified-preview-comment user-select-none img-verificado-comentario" />
                            </h1>

                            {newGif ? (
                                <img
                                    src={newGif}
                                    className="comment-gif"
                                    alt="GIF"
                                />
                            ) : (
                                <p dangerouslySetInnerHTML={{ __html: clearText(censorText(newComment)) }} className="text-preview-comment" style={{ marginTop: "5px!important" }}></p>
                            )}


                            {/* {{-- icone enviado --}} */}
                            <div className="d-flex w-100 div-status-comment" style={{ justifyContent: "right" }}>
                                {isSendComment ? (
                                    <CheckCircle className="comment-father icon-feather-blue" data-feather="check-circle" />
                                ) : (
                                    <Clock className="comment-father" opacity={.6} data-feather="clock" />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}

            {/* form para comentar */}
            {formNewCommentVisible ? (
                <div className="row row-comment row-preview-comment" style={{ marginTop: "20px" }}>
                    <div className="col-1 img-account-add-comment" style={{ backgroundImage: `url("${img}")`, display: "none" }}>
                    </div>

                    <div className="col user-select-none" style={{padding: 0}}>
                        {aiLimitBannerName ? <AiLimitBanner aiName={aiLimitBannerName} /> : null}
                        <form onSubmit={handleSubmitComment} className="form-comment" id='form-add-comment'>
                            <div className="d-flex">
                                <div style={{ width: "100%", position: "relative", paddingRight: "5px" }}>
                                    <div style={{ display: "flex" }}>
                                        <div className="btn-emoji-comment" ref={buttonRef} onClick={() => setShowEmoji(true)}>
                                            <div className="cursor-pointer div-emoji-chat">
                                                <Laugh className="icon-comment-sticky"/>
                                            </div>
                                        </div>
                                        <textarea
                                            rows={1}
                                            value={text}
                                            ref={textareaRef}
                                            className="textarea-comment-emoji form-control text-comment me-2"
                                            placeholder="Adicionar comentário"
                                            required
                                            onChange={(e) => handleInputTextarea(e)}
                                            onKeyDown={(e) => handleKeyDown(e)}
                                            style={{ background: "transparent!important" }}
                                        />
                                    </div>
                                    <EmojiPickerNative
                                        show={showEmoji} 
                                        setShow={setShowEmoji} 
                                        onSelect={(emoji) => { 
                                            setText(prev => prev + emoji); 
                                            // textareaRef.current?.focus() 
                                        }}  
                                        handleClickGif={handleClickGif}
                                        bottom={window.innerWidth <=850 ? `${String(bottomPadding + (window.innerWidth <=850 ? 10 : parseFloat(textareaRef.current?.style.height || '0') * -1))}px` : ""}
                                    />
                                    <PreviewSearch 
                                        textareaRef={textareaRef} 
                                        text={text} 
                                        setText={setText}
                                    />
                                    {/* <div className='div-info-textarea'>
                                        <div className='cursor-pointer icon-add-emoji' ref={buttonRef} onClick={handleClickEmoji}>
                                            <Smile className='icon-add-emoji' />
                                        </div>
                                        <div className="user-select-none limite-post" style={{ color: isLimitExceeded ? "red" : "inherit" }}>
                                            {text.length}/{LIMIT_TEXT_COMMENT}
                                        </div>
                                    </div> */}
                                </div>

                                {/* <EmojiPicker textareaRef={textareaRef} updateText={updateText} / > */}
                                <button style={{borderRadius: "50%" }} disabled={disabled} className="user-select-none btn btn-blue button-submit-comment button-submit-comment-feed btn-withou-shadow" type="submit">
                                    <Send className="icon-send-comment icon-send-comment-feed" data-feather="send" style={{ height: "10px!important", width: "10px!important", }} />
                                </button>
                            </div>

                            <div className="user-suggestions" style={{ display: "none", position: "absolute", background: "white", border: "1px solid #ccc", zIndex: "1000", maxHeight: "200px", overflowY: "auto" }}></div>

                        </form>
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default OptionsPost;
